<script>
export default {
	props: [ 'default' ],
	// data: () => ({
	// 	shown: this.default
	// }),
	data() {
		return {
			shown: this.default
		}
	},
	methods: {
		show(changelog) {
			this.shown = changelog
		},
		isShown(changelog) {
			return this.shown == changelog
		}
	}
}
</script>
